import styled from "styled-components";

export const Container = styled.div``;

export const Title = styled.h3``;

export const Subtitle = styled.h6`
  margin: 20px 0;
`;
